export function generateDPIA(options: { modules: string[]; dataFlows: string[] }): { items: Array<{ id:string; desc:string; status:'ok'|'review' }> } {
  const base = [
    { id:'lawful_basis', desc:'Lawful basis documented', status:'ok' as const },
    { id:'data_min', desc:'Data minimization applied', status:'ok' as const },
    { id:'dpia_required', desc:'DPIA screening', status: options.modules.length>10? 'review' : 'ok' as const }
  ];
  return { items: base };
}



















